import { forwardRef } from 'react'
import { Input as ChakraInput, InputProps } from '@chakra-ui/react/input'

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <ChakraInput ref={ref} {...props} bgColor="ge.white" color="ge.text.primary" />
})

export default Input
